// server url
export const SERVER_URL = 'http://194.87.239.163:80/back/backServlet';
export const POST_REQ_TYPE = 'POST';